/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';

export const stats = (state = defaultState.stats, action) => {
    let nextState = Utilities.deepClone(state),
        i = 0;

    if (action.status === constants.STATE_TXRX) {
        switch (action.type) {
            case constants.STATS_FETCH_SOCIAL:
                nextState.social.id = action.id;
                nextState.social.data = {};
                break;

            case constants.STATS_FETCH_SOCIAL_POSTS:
            case constants.STATS_FETCH_ROUTE_POSTS:
            case constants.STATS_FETCH_ALL_POSTS:
                if (action.post.page === 1) {
                    nextState.socialPosts.id = action.id;
                    nextState.socialPosts.data = [];
                    nextState.routePosts.id = action.id;
                    nextState.routePosts.data = [];
                    nextState.allStatsPosts.data = [];
                }
                break;

            case constants.STATS_FETCH_ROUTE:
                nextState.route.id = action.id;
                nextState.route.data = {};
                break;

            default:
                break;
        }
    } else if (action.status === constants.STATE_SUCCESS) {
        switch (action.type) {
            case constants.STATS_FETCH_SOCIAL:
                nextState.social.data = action.payload;
                break;

            case constants.STATS_FETCH_SOCIAL_POSTS:
                if (action.payload.length) {
                    for (i = 0; i < action.payload.length; ++i) {
                        nextState.socialPosts.data.push(action.payload[i]);
                    }
                }
                break;

            case constants.STATS_FETCH_ROUTE:
                nextState.route.data = action.payload;
                break;

            case constants.STATS_FETCH_ROUTE_POSTS:
                if (action.payload.length) {
                    for (i = 0; i < action.payload.length; ++i) {
                        nextState.routePosts.data.push(action.payload[i]);
                    }
                }
                break;

            case constants.STATS_FETCH_ALL:
                nextState.allStats.data = action.payload;
                break;

            case constants.STATS_FETCH_ALL_POSTS:
                if (action.payload.length) {
                    for (i = 0; i < action.payload.length; ++i) {
                        nextState.allStatsPosts.data.push(action.payload[i]);
                    }
                }
                break;

            case constants.STATS_FETCH_GEO:
                nextState.geo.data = {};
                if (Object.keys(action.payload).length) {
                    nextState.geo.data = action.payload;
                }
                break;

            default:
                break;
        }
    }

    return nextState;
};
